import { useRef } from "react";
import { motion } from "framer-motion";
import { ArrowDownRight, Sparkles } from "lucide-react";
import { MaskLine } from "./Reveal";
import { IMAGES, CONTACT, SHOW_MEDIA } from "../../data";

export default function Hero() {
  const ref = useRef(null);

  return (
    <section ref={ref} id="top" className="relative min-h-screen w-full overflow-hidden bg-white" data-testid="hero">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 pt-32 md:pt-40 pb-16 grid lg:grid-cols-12 gap-10 items-end min-h-screen">
        <div className="lg:col-span-7 relative z-10">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
            className="flex items-center gap-2 text-xs md:text-sm tracking-[0.25em] uppercase text-royal font-semibold mb-6"
          >
            <Sparkles size={15} /> Limpeza de vidros profissional
          </motion.div>

          <h1 className="font-display font-extrabold text-ink tracking-tight text-[3.2rem] leading-[0.95] sm:text-6xl lg:text-[6.2rem]">
            <MaskLine delay={0.35}>A arte de</MaskLine>
            <MaskLine delay={0.47}>ver através</MaskLine>
            <MaskLine delay={0.59}><span className="font-serif-ed italic font-medium text-royal">do vidro.</span></MaskLine>
          </h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.9, duration: 0.7 }}
            className="mt-8 max-w-xl text-base md:text-lg text-muted-foreground leading-relaxed"
          >
            Comércio, residências, painéis solares, complexos desportivos e supermercados.
            Vidros impecáveis, feitos com rigor e paixão — marque online em segundos.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.05, duration: 0.7 }}
            className="mt-10 flex flex-wrap items-center gap-4"
          >
            <a href="#marcacao" className="group inline-flex items-center gap-2 rounded-full bg-royal text-white font-semibold px-7 h-14 text-base hover:bg-[#003380] transition-colors" data-testid="hero-book-btn">
              Fazer marcação
              <ArrowDownRight size={20} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:translate-y-1" />
            </a>
            <a href="#servicos" className="link-underline inline-flex items-center h-14 font-medium text-ink" data-testid="hero-services-link">
              Ver serviços
            </a>
          </motion.div>
        </div>

        {SHOW_MEDIA && (
        <div className="lg:col-span-5 relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 60 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 1, ease: [0.22, 1, 0.36, 1] }}
            className="relative aspect-[3/4] w-full max-w-md ml-auto overflow-hidden rounded-[2rem] shadow-[0_30px_80px_rgba(0,47,171,0.18)]"
          >
            <motion.img
              src={IMAGES.hero}
              alt="Fernando, especialista em limpeza de vidros"
              decoding="async"
              fetchPriority="high"
              className="absolute inset-0 h-full w-full object-cover"
            />
            <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/60 to-transparent">
              <p className="font-display font-bold text-white text-lg">Fernando</p>
              <p className="text-white/80 text-sm">{CONTACT.instagramHandle}</p>
            </div>
          </motion.div>
        </div>
        )}
      </div>

      <div className="hidden md:block pointer-events-none absolute -right-20 top-1/4 h-[420px] w-[420px] rounded-full bg-accent/20 blur-[60px]" />
      <div className="hidden md:block pointer-events-none absolute -left-24 bottom-10 h-[360px] w-[360px] rounded-full bg-royal/10 blur-[60px]" />
    </section>
  );
}
